module.exports = __webpack_public_path__ + "static/media/sp_menu_1_20230419.c2479348.webp";